import { Create, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { StaffFormFields } from './StaffForm';

export const StaffCreate = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="staff" />}>
      <MyFormContainer>
        <StaffFormFields isCreate />
      </MyFormContainer>
    </SimpleForm>
  </Create>
);

export default StaffCreate;
